import { Button, Statistic } from "@arco-design/web-react";

import { canConfirmImport } from "../service/crmCollaborationTaskService";
import type { CrmCollaborationTaskImportResult } from "../types";

type Props = {
  result?: CrmCollaborationTaskImportResult;
  confirming: boolean;
  onConfirm: () => void;
};

/** 展示任务对象导入校验摘要，并控制是否允许确认导入。 */
export function CrmCollaborationTaskImportPreviewCard({ result, confirming, onConfirm }: Props) {
  if (!result) {
    return (
      <section className="crm-list-panel crm-collaboration-task-card">
        <div className="crm-list-section-header">
          <h2>导入校验预览</h2>
        </div>
        <div className="crm-list-panel-body">
          暂未生成导入预览。先粘贴联系人 ID，并创建任务草稿。
        </div>
      </section>
    );
  }

  return (
    <section className="crm-list-panel crm-collaboration-task-card">
      <div className="crm-list-section-header">
        <h2>导入校验预览</h2>
      </div>
      <div className="crm-list-panel-body">
      <div className="crm-collaboration-task-stat-grid">
        <Statistic title="解析总数" value={result.parsedCount} />
        <Statistic title="有效 ID" value={result.validCount} />
        <Statistic title="无效 ID" value={result.invalidCount} />
        <Statistic title="重复 ID" value={result.duplicateCount} />
        <Statistic title="停用对象" value={result.disabledCount} />
        <Statistic title="未释放冲突" value={result.activeTaskConflictCount} />
        <Statistic title="可导入" value={result.importableCount} />
      </div>
      <Button type="primary" loading={confirming} disabled={!canConfirmImport(result)} onClick={onConfirm}>
        确认导入
      </Button>
      </div>
    </section>
  );
}
